import * as z from 'zod';

export const userRoleQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string().min(3),
  azure_role_id: z.string().nullable(),
});

export type UserRoleQueryLinkerSchema = z.infer<typeof userRoleQueryLinkerSchema>;
